import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { IInputNumberProps } from 'components/uiKit/InputNumber'
import InputNumber from 'components/uiKit/InputNumber'

import InputNumberArray from './InputNumberArray'

export interface IArrayOption extends Omit<IInputNumberProps, 'name' | 'value' | 'onChange'> {
  icon?: string | JSX.Element
}

export interface IProps extends Omit<IInputNumberProps, 'value' | 'onChange' | 'defaultValue'> {
  value: number | (number | undefined)[] | string | null
  defaultValue: number | (number | undefined)[] | string | null
  onChange: (value: number | (number | undefined)[] | string | null) => void
  array?: IArrayOption[]
}

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldNumber: React.FC<IControlProps<IProps>> = ({
  name,
  onChange,
  value,
  array,
  defaultValue,
  ...rest
}) => {
  const onChangeWrapper = useCallback(
    (value?: number | (number | undefined)[] | string | null) => onChange({ name, value }),
    [name, onChange],
  )
  const newValue = value ?? defaultValue

  if (array) {
    return (
      <InputNumberArray
        {...rest}
        array={array}
        defaultValue={defaultValue as number[]}
        name={name}
        onChange={onChangeWrapper}
        value={newValue as number[]}
      />
    )
  }

  return <InputNumber {...rest} name={name} onChange={onChangeWrapper} value={newValue as number} />
}
export default FieldNumber
